import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import image from './library@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="library-at-the-heart-of-our-program">
    <h1>圖書館是課程的核心</h1>
    <p>
      京斯敦的圖書館在推行小學文憑課程上扮演着重要的角色。我們提供全面的學習資源支持課程需要，包括網上學習資源及印刷版學習資源。我們計劃及促進各級的學習，致力訓練學生的讀寫技巧及資料蒐集技巧，通過培養他們的批判思維和學術誠信，使其成為負責任的終生學習者。
    </p>
    <h3>培養閱讀</h3>
    <p>
      閱讀是京斯敦大家庭內非常重要的一環。我們培養學生的閱讀能力，提供接觸不同形式的資訊的渠道。我們的電子資料庫——《大英百科全書》及
      Big
      Universe——為學生提供適合其年齡的可信資源作資料蒐集之用。學生亦可閱讀兒童適宜的網上新聞及網站。我們提供最新且全面的學習資源，以支援研究及教學所需。
    </p>
    <h3>鼓勵發表意見，提倡發揮創意</h3>
    <p>
      我們每年都會舉辦圖書週，藉以推廣閱讀。學校會邀請作家、插畫家及出版社到校演講，讓學生透過認識不同的角色和觀點開闊個人思維。學生會在圖書週打扮成自己最喜愛的圖書角色，並與其他年級的學生分享閱讀。圖書館是連繫學生及促進合作的理想之處，歡迎各位陶醉於多姿多彩的書本世界。
    </p>
    <img src={image} alt="Library at the heart of our program" />
  </ContentLayout>
);
